import {createSelector} from "reselect";
import {getCountriesIsLoading, getIsLoadingTeams} from "modules/selectors/jsons";

export const getRegistrationIsLoading = createSelector(
	getIsLoadingTeams,
	getCountriesIsLoading,
	(teamsIsLoading, countriesIsLoading) => teamsIsLoading || countriesIsLoading
);
